import {
    Accordion,
    AccordionDetails,
    AccordionSummary,
    Autocomplete,
    Avatar,
    Box,
    Button,
    Card,
    CardContent, InputAdornment,
    MenuItem,
    Popper,
    PopperProps,
    Select,
    TextField,
    Typography
} from '@mui/material';
import { debounce, filter, isEmpty } from 'lodash';
import { FC, UIEvent, useEffect, useMemo, useRef, useState } from 'react';
import { API_SLUGS, GROUP_ROLES } from '../../../constants';
import { Mail as MailIcon } from '../../../icons/mail';
import { axiosInstance } from '../../../services/axios';
import { useAlertState } from '../../../store/alertState';
import MaterialReactTable from 'material-react-table';
import { makeStyles } from "@material-ui/styles";
import { ChevronDown } from '../../../icons/chevron-down';
import { useTableInfinity } from '../../../hooks/process/useTableInfinity';
var format = require("string-template")

const limit = 20;
const disableInfiniteScroll = false;
export const InviteTable: FC = () => {
    const [emails, setEmails] = useState('')
    const [groups, setGroups] = useState<any[]>([]) as any
    const setMessage = useAlertState(state =>
        //@ts-ignore
        state.setMessage)
    const [role, setRole] = useState("maintainer")
    const [groupRole, setGroupRole] = useState('') as any
    const [group, setGroup] = useState<any>(null)
    const [loading, setLoading] = useState(false)
    const [showOptions, setShowOptions] = useState(false)
    const [searchQuery, setSearchQuery] = useState("");
    const invitesUrl = API_SLUGS.GET_INVITES + `?limit={limit}&offset={offset}`;
    const invitesUrlToUse = useMemo(() => invitesUrl + `&search=${searchQuery}`, [searchQuery])

    const tableContainerRef = useRef<HTMLDivElement>(null);
    const { rows, fetchMoreOnBottomReached, isFetching, resetAndFetch } = useTableInfinity(
        "invites",
        invitesUrlToUse,
        tableContainerRef,
        limit
    );


    useEffect(() => {
        if (!disableInfiniteScroll) {
            fetchMoreOnBottomReached(tableContainerRef.current);
        }
    }, [fetchMoreOnBottomReached])


    useEffect(() => {
        fetchGroups()
    }, [])



    const fetchGroups = async (searchQuery?: string | null) => {

        try {
            let groups = await axiosInstance.get(`${API_SLUGS.GET_GROUPS}?limit=20${searchQuery ? `&search=${encodeURIComponent(searchQuery)}` : ''}`)
            setGroups(groups.data?.groups)
        } catch (error: any) {
            setMessage({ title: error.response?.data?.message, type: "error" });
        }

    }

    const handleAction = async (id: string, action: "resend" | "cancel") => {

        try {
            await axiosInstance.patch(format(API_SLUGS.ACTION_INVITES, { id: id }), { action: action })
            resetAndFetch();
            if (action === "resend") {
                setMessage({ title: "Invite Resent", type: "success" });
            }
        } catch (error: any) {
            setMessage({ title: error.response?.data?.message, type: "error" });
        }

    }



    const handleSubmit = async () => {
        try {
            let payload;
            if (group !== null || groupRole !== '') {
                payload = {
                    "invites": [
                        {
                            "email": emails,
                            "type": "organization",
                            role,
                            "groups": [
                                {
                                    "id": group,
                                    "role": groupRole
                                }
                            ]
                        }
                    ]
                }
            } else {
                payload = {
                    "invites": [
                        {
                            "email": emails,
                            "type": "organization",
                            role
                        }
                    ]
                }
            }
            let invitesResponse = await axiosInstance.post(API_SLUGS.SEND_INVITES, payload)
            resetAndFetch()
            // refetchOrganizationMembers()
            setEmails("");
            setGroupRole('');
            setGroup(null);
            setMessage({ title: "Invite Sent", type: "success" });

        } catch (error: any) {
            setMessage({ title: error.response?.data?.message, type: "error" });
        }
    }

    const toggleShowOptions = () => {
        setShowOptions(!showOptions)
    }

    const debouncedFetchGroups = debounce(fetchGroups, 300);

    const handleGroupSearchChange = (event: any, value: string) => {
        if (value) {
            debouncedFetchGroups(value);
        } else {
            debouncedFetchGroups(null);
        }
    };

    const handleGroupChange = (value: any) => {
        setGroup(value)
    }

    const useStyle = makeStyles(() => ({
        popperRoot: {
            [`& .MuiAutocomplete-noOptions`]: {
                display: 'none'
            }
        }
    }))
    const debouncedFetchMembers = debounce(setSearchQuery, 300);

    const handleSearchChange = (event: any) => {
        const searchQuery = event?.target?.value;
        if (searchQuery || searchQuery === "") {
            debouncedFetchMembers(searchQuery);
        } else {
            resetAndFetch()
        }
    };
    //@ts-ignore
    const classes = useStyle()

    return <Card sx={{ textAlign: "left" }}>
        <CardContent>
            <div>
                <Typography variant="h6" sx={{ pl: 1, mb: 2 }}>
                    Invite
                </Typography>

            </div>

            <Box
                sx={{
                    alignItems: 'center',
                    display: 'flex',
                    flexWrap: 'wrap',
                    justifyContent: 'space-between',
                    mb: 0,
                }}
            >
                <TextField
                    label="Email address"
                    size="medium"
                    sx={{
                        m: 1.5,
                        flex: 1.1,
                        minWidth: "12em"
                    }}

                    value={emails}
                    placeholder='Enter email address'
                    onChange={({ target }) => setEmails(target.value)}
                    InputProps={{
                        startAdornment: (
                            <InputAdornment position="start">
                                <MailIcon fontSize="small" />
                            </InputAdornment>
                        )
                    }}
                />
                <Autocomplete
                    sx={{ minWidth: "10em", textAlign: "left", flexGrow: 1 }}
                    size="medium"
                    getOptionLabel={(option): any => option.name}
                    options={GROUP_ROLES || []}
                    onChange={(e, value) => {
                        setRole(value.key);
                    }}
                    value={GROUP_ROLES.find(
                        (r: any) => r.key === role
                    )}
                    filterOptions={(options, params) => {

                        const filtered = filter(options, function (item: any) {
                            return item?.key?.indexOf(params.inputValue) > -1;
                        });

                        return filtered;
                    }}
                    disableClearable

                    renderInput={(params): JSX.Element => {
                        return (
                            <TextField
                                autoComplete="off"
                                name="id"
                                variant="outlined"
                                label="Organization Role"
                                {...params}
                            />
                        );
                    }}
                />


            </Box>


            <Accordion
                defaultExpanded={false}
                sx={{ textAlign: 'left', mt: 2, p: 0, pb: 1 }}
            >
                <AccordionSummary expandIcon={<ChevronDown />}>
                    <Typography
                        color="textPrimary"
                        sx={{ mb: 1, textAlign: "left" }}
                        variant="body2"
                    >
                        Group (Optional)
                    </Typography>
                </AccordionSummary>
                <AccordionDetails sx={{ p: 0, pr: 1 }}>
                    <Box
                        sx={{
                            alignItems: 'center',
                            display: 'flex',
                            flexWrap: 'wrap',
                            justifyContent: 'space-between',
                            mb: 0,
                        }}
                    >
                        <Autocomplete
                            sx={{ ml: 1.5, textAlign: "left", flex: 1 }}
                            PopperComponent={(props: PopperProps) =>
                                <Popper {...props} disablePortal className={classes.popperRoot} placement="bottom" sx={{ zIndex: 9999 }} />
                            }
                            size="medium"
                            getOptionLabel={(option): any => option?.name}
                            options={groups}
                            forcePopupIcon={false}
                            value={group === null ? null : groups.find((grp: any) => grp.id === group)}
                            onInputChange={handleGroupSearchChange}
                            onChange={(e, value) => {
                                if (value) {
                                    handleGroupChange(value?.id);

                                }
                            }}
                            clearOnBlur
                            renderInput={(params): JSX.Element => {
                                return (
                                    <TextField
                                        autoComplete="off"
                                        name="group"
                                        placeholder="Search for Group"
                                        variant="outlined"
                                        {...params}
                                    />
                                );
                            }}
                        />
                        <Autocomplete
                            sx={{ minWidth: "10em", textAlign: "left", flex: 1, ml: 1.5 }}
                            size="medium"
                            getOptionLabel={(option): any => option.name}
                            options={GROUP_ROLES || []}
                            onChange={(e, value) => {
                                if (value) {
                                    setGroupRole(value?.key);
                                }
                            }}
                            value={groupRole === '' ? null : GROUP_ROLES.find(
                                (r: any) => r.key === groupRole
                            )}
                            filterOptions={(options, params) => {

                                const filtered = filter(options, function (item: any) {
                                    return item?.key?.indexOf(params.inputValue) > -1;
                                });

                                return filtered;
                            }}

                            renderInput={(params): JSX.Element => {
                                return (
                                    <TextField
                                        autoComplete="off"
                                        name="id"
                                        variant="outlined"
                                        label="Group Role"
                                        {...params}
                                    />
                                );
                            }}
                        />
                    </Box>
                </AccordionDetails>
            </Accordion>
            <Box
                sx={{
                    alignItems: 'center',
                    display: 'flex',
                    flexWrap: 'wrap',
                    justifyContent: 'space-between'
                }}
            >
                <Button
                    sx={{ m: 1.5 }}
                    variant="contained"
                    onClick={handleSubmit}

                >
                    Send Invite
                </Button>

            </Box>
        </CardContent>
        <Card sx={{ textAlign: "left", margin: "0px 20px" }}>

            <TextField
                onChange={(e: any) => {
                    handleSearchChange(e);
                }}
                sx={{ m: 1, minWidth: "14em", pr: 3, my: 2, width: "98%" }}

                autoComplete="off"
                name="id"
                variant="outlined"
                placeholder="Search Invites"
            />
            <MaterialReactTable muiTablePaperProps={{
                elevation: 0
            }} enableGlobalFilter={false}
                columns={[
                    {
                        accessorKey: "email",
                        header: "Invitations",
                        Cell: (params: any) => {
                            const member = params?.row?.original;
                            return (<Box
                                sx={{
                                    display: 'flex',
                                    alignItems: 'center',
                                    width: '100%'
                                }}
                            >
                                <Avatar
                                    alt={member?.email}

                                    sx={{
                                        height: 40,
                                        width: 40,
                                        mr: 1
                                    }}
                                >
                                    {member?.email?.[0]}
                                </Avatar>
                                {member?.email}
                            </Box>

                            )
                        },
                        size: 50
                    },
                    {
                        accessorKey: "role",
                        header: "Organization Role",
                        Cell: (params: any) => {
                            const row = params?.row?.original;
                            const label = GROUP_ROLES.find((role) => role.key === row.role)?.name
                            return (
                                <>{label}</>
                            );
                        },
                        size: 50
                    },
                    {
                        accessorKey: "groups.name",
                        header: "Group",
                        Cell: (params: any) => {
                            return params?.row?.original?.groups?.[0]?.name
                        },
                        size: 80
                    },
                    {
                        accessorKey: "groups.role",
                        header: "Group Role",
                        Cell: (params: any) => {
                            const row = params?.row?.original?.groups?.[0]?.role;
                            const label = GROUP_ROLES.find((role) => role.key === row)?.name
                            return (
                                <>{label}</>
                            );
                        },
                        size: 50
                    },
                    {
                        accessorKey: "actions",
                        header: "Actions",
                        Cell: (params: any) => {
                            const row = params?.row?.original;
                            return (
                                <Box sx={{ display: "flex", justifyContent: "start" }}>
                                    <Button onClick={() => handleAction(row.id, "resend")}>
                                        Resend
                                    </Button>
                                    <Button onClick={() => handleAction(row.id, "cancel")}>
                                        Cancel
                                    </Button>
                                </Box>
                            );
                        },
                        size: 50
                    },
                ]}
                data={rows}
                initialState={{
                    density: "compact",
                    columnPinning: { left: ['id'] },

                }}
                enableColumnActions={false}
                enableSorting={false}
                enableStickyHeader
                muiTableContainerProps={{
                    ref: tableContainerRef, //get access to the table container element
                    sx: { maxHeight: "calc(80vh - 300px)", overflow: "auto" }, //give the table a max height
                    onScroll: (
                        event: UIEvent<HTMLDivElement> //add an event listener to the table container element
                    ) => {
                        if (!disableInfiniteScroll) {
                            fetchMoreOnBottomReached(event.target as HTMLDivElement)
                        }

                    },

                }}

                enableTopToolbar={false}
                enablePagination={false}
                enableDensityToggle={false}
                enableColumnFilters={false}
                // enableRowVirtualization
                state={{
                    showProgressBars: loading,
                }}
            />
        </Card>
    </Card>
};
